import { engineRequest } from './http';

// `status` is `active`, `archived` or `all`; `kind` is `technician`,
// `operations`, `supervisor` or `building_management`. A plain array, no paging.
export const listRoles = params => engineRequest({ path: '/roles', params });

export const createRole = fields =>
  engineRequest({ method: 'post', path: '/roles', data: fields });

// `key` is immutable. Archive a role with `active: false`.
export const updateRole = (key, fields) =>
  engineRequest({ method: 'put', path: `/roles/${key}`, data: fields });

// 409 `in_use` (with `used_by`) when members, routing or tickets use it.
export const deleteRole = key =>
  engineRequest({ method: 'delete', path: `/roles/${key}` });
